import { InjectionToken } from "@angular/core";
import { CompanyLawModificationsPort } from "./company-law-modifications.port";

export const COMPANY_LAW_MODIFICATIONS_PORT =
  new InjectionToken<CompanyLawModificationsPort>(
    "COMPANY_LAW_MODIFICATIONS_PORT",
  );
